
import { computed, ref } from 'vue';
import useConverter from '@/composables/general/useConverter';
import SocialSharing from '@/components/general/WdwSocialSharing.vue';
import AttributeList from '@/components/discuss/thought/AttributeTags.vue';
import useThoughtHelpers from '@/composables/thought/useThoughtHelpers';
import useStringManip from '@/composables/general/useStringManip';

export default {
  name: 'ThoughtInList',
  components: { SocialSharing, AttributeList },
  props: {
    thought: { type: Object, required: true },
    thoughtListHeight: {
      type: Number,
      default: 250,
    },
  },

  setup(props: any) {
    //REF
    const { formattedDate } = useConverter();
    const { getCurrenThoughtUri } = useThoughtHelpers();
    const { getPlainText } = useStringManip();

    //COMPUTED
    const imgStyle = computed(() => {
      return { height: props.thoughtListHeight + 'px' };
    });

    //METHODS
    function openSingleThought() {
      window.location.href = getCurrenThoughtUri(props.thought.id);
    }

    return {
      getPlainText,
      //REF
      formattedDate,
      //COMPUTED
      imgStyle,
      //METHODS
      getCurrenThoughtUri,
      openSingleThought,
    };
  },
};
